/**
 * Created by ivan on 10.05.18.
 */

const LollipopCellView = BaseCellView.extend({
    ctor: function (lollipopCell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        this.initialize(lollipopCell);

        this.setCascadeOpacityEnabled(true);
    },

    initialize: function (lollipopCell) {
        this._super(lollipopCell);

        lollipopCell.onChangeColorListener = this.createListener(this.changeColorAnimation.bind(this));
    },

    changeColorAnimation: function (cell, oldColor, newColor) {
        this.finishSmile();
        const animation = LollipopAnimation.factory(oldColor, this.cell.bundleId());
        animation.setPosition(this.width / 2, this.height / 2);
        animation.setLocalZOrder(1);
        this.addChild(animation);
        this.changingColor = true;

        animation.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.CallFunc(() => {
                animation.setSkin(LollipopColorsMap[newColor]);
            })
        ));

        const colorComponent = this.cell.findComponent(ColorComponent);
        animation.runAnimate("animation", () => {
            colorComponent.view.updateImage(cell);
            colorComponent.view.show();

            this.changingColor = false;
            animation.setSkin(LollipopColorsMap[oldColor]);
        }, colorComponent.view.image);

        cleverapps.effects.fire(`match3.${cell.bundleId()}.change_color`);
    },

    finishSmile: function () {
        if (this.smiling) {
            this.smiling = false;

            const colorComponent = this.cell.findComponent(ColorComponent);
            colorComponent.view.show();

            this.animation.finishAnimation();
        }
    },

    smile: function () {
        if (!cleverapps.styles.LollipopCellView.smile || !cleverapps.Spine.hasAnimation("smile", bundles[this.cell.bundleId()].jsons.lollipop_json)) {
            return;
        }

        if (this.smiling || this.changingColor) {
            return;
        }

        this.animation = LollipopAnimation.factory(this.cell.findComponent(ColorComponent).color, this.cell.bundleId());
        this.addChild(this.animation);
        this.animation.setAlignment(this.width / 2, this.height / 2);

        const colorComponent = this.cell.findComponent(ColorComponent);
        this.smiling = true;
        this.animation.runAnimate("smile", this.finishSmile.bind(this), colorComponent.view.image);

        cleverapps.effects.fire(`match3.${this.cell.bundleId()}.smile`);
    },

    unuse: function () {
        this.cell.onChangeColorListener = function () {};

        this._super();
    },

    startExploding: function (goal, delta) {
        cleverapps.effects.fire(`match3.${this.cell.bundleId()}.collect`);
        this.startExplodingViaCollect(goal, delta);
    }
});

cleverapps.styles.LollipopCellView = {
    smile: false
};